import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Footer12 from "../shared/Footer12";
import Navbar12 from "../shared/Navbar12";
import Sidebar12 from "../shared/Sidebar12";
import $ from "jquery";
import config from "../../config";
import Swal from "sweetalert2";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

function GenerateChallan12() {
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const iframeRef = useRef(null);
  const navigate = useNavigate();

  const [challanlimit, setChallanlimit] = useState("");
  const [challancount, setChallancount] = useState("");

  const [EndDate, setEndDate] = useState("");
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const currentDate = `${day}-${month}-${year}`;
  const parseDate = (str) => {
    const [dd, mm, yyyy] = str.split("-");
    return new Date(`${yyyy}-${mm}-${dd}`);
  };

  const [searchQuery, setSearchQuery] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);

  const filteredStudents = tableData.filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      student.candidatE_NAME?.toLowerCase().includes(query) ||
      student.gender?.toLowerCase().includes(query) ||
      student.dob?.toLowerCase().includes(query) ||
      student.fatheR_NAME?.toLowerCase().includes(query) ||
      student.motheR_NAME?.toLowerCase().includes(query) ||
      student.aadhaR_CARD?.toLowerCase().includes(query) ||
      student.studenT_EXAM_CATEGORY_DESCRIPTION
        ?.toLowerCase()
        .includes(query) ||
      student.contacT_NO?.toLowerCase().includes(query)
    );
  });

  useEffect(() => {
    const fetchData = async () => {
      const token = sessionStorage.getItem("tokenclassxii");

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/FetchStudentDataForGenerateChallan_CL12`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            // body: JSON.stringify({ schooL_CODE: schoolCode }),
          }
        );
        setIsLoading(false);
        const data = await response.json();
        console.log("Fetched data:", data);
        setTableData(data.data.candidatelist || []);
        setChallanlimit(data.data.challanEndDate?.challaN_LIMIT || "");
        setChallancount(data.data.challanEndDate?.challaN_COUNT || "");
        setEndDate(data.data.challanEndDate.cL_12_CHALLAN_END_DATE || "");
      } catch (error) {
        setIsLoading(false);
        console.error("Failed to fetch candidate data:", error);
      }
    };

    fetchData();
  }, []);

  const generateChallan = async () => {
    const token = sessionStorage.getItem("tokenclassxii");
    const candidateIds = tableData.map((item) => item.candidatE_ID).join(",");

    Swal.fire({
      title: "Are you sure?",
      html: `Do you want to generate the challan ?<br> 
           <h4 style="font-weight:600;color:red">
             challan generation left : ${challanlimit - challancount}
           </h4>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Generate",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        try {
          const response = await fetch(
            `${config.API_BASE_URL}/ChallanNumberGenerate_CL12`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                // schooL_CODE: schoolCode,
                candidatE_ID: candidateIds,
              }),
            }
          );

          setIsLoading(false);
          const data = await response.json();

          if (response.ok) {
            // const responseData = await response.json();
            console.log("Challan generation response:", data);
            const challanNo = data?.data.challanNo || null;

            if (challanNo) {
              sessionStorage.setItem("challanNo", challanNo);

              openModal2(challanNo);
            } else {
              Swal.fire(
                "Error!",
                "Challan generated but no Challan Number found.",
                "error"
              );
            }
            // Swal.fire("Success!", "Challan generated successfully.", "success");
            // navigate("/class-ix-generate-challan");
          } else {
            Swal.fire(
              "Error!",
              data.message || "Something went wrong.",
              "error"
            );
          }
        } catch (error) {
          setIsLoading(false);
          console.error("Failed to generate challan:", error);
          Swal.fire(
            "Error!",
            "Failed to generate challan. Please try again.",
            "error"
          );
        }
      }
    });
  };

  const openModal2 = (challanNo) => {
    sessionStorage.setItem("challanNo", challanNo);
    // localStorage.setItem("modalOpen", "true");
    $("#pdfModal").addClass("show").css("display", "block");
    $("body")
      .addClass("modal-open")
      .append('<div class="modal-backdrop fade show"></div>');
    const pdfUrl = `/generate-pdf-class-xii`;
    if (iframeRef.current) {
      iframeRef.current.src = pdfUrl;
    }
  };
  const closeModal2 = () => {
    $("#pdfModal").removeClass("show").css("display", "none");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove(); // Remove the backdrop

    window.location.reload(); // Reload the page when the modal is closed
  };
  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  return (
    <>
      <div class="container-scroller">
        <Navbar12 />
        {isLoading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}
        {/*  */}
        <div class="container-fluid page-body-wrapper">
          <Sidebar12 />
          <div class="main-panel">
            <div class="content-wrapper">
              <section class="content-header">
                <h1>
                  <i className="fa fa-user"></i>&nbsp; Generate Challan (
                  Challan Limit : {challanlimit} || Challan Generation Left :{" "}
                  {challanlimit - challancount} )
                </h1>
                <ol class="breadcrumb">
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/class-xii-dashboard");
                      }}
                    >
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 512 512"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ marginTop: "-4px" }}
                      >
                        <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                      </svg>{" "}
                      Home&nbsp;
                    </a>
                  </li>
                  <li class="active"> Generate Challan</li>
                </ol>
                <h3></h3>
              </section>

              <div className="card">
                <div className="card-body">
                  {/* <div className="row mb-3">
                    <div style={{ width: "20%", cursor: "pointer" }}>
                      <div
                        className="p-3 text-white text-center rounded"
                        style={{ backgroundColor: "#007bff" }}
                      >
                        Generate Challan <br /> (1–200 Students)
                      </div>
                    </div>
                    <div style={{ width: "20%", cursor: "pointer" }}>
                      <div
                        className="p-3 text-white text-center rounded"
                        style={{ backgroundColor: "#28a745" }}
                      >
                        Generate Challan <br /> (201–400 Students)
                      </div>
                    </div>
                    <div style={{ width: "20%", cursor: "pointer" }}>
                      <div
                        className="p-3 text-white text-center rounded"
                        style={{
                          backgroundColor: "#ffc107",
                          color: "#000",
                        }}
                      >
                        Generate Challan <br /> (401–600 Students)
                      </div>
                    </div>
                    <div style={{ width: "20%", cursor: "pointer" }}>
                      <div
                        className="p-3 text-white text-center rounded"
                        style={{ backgroundColor: "#dc3545" }}
                      >
                        Generate Challan <br /> (601–800 Students)
                      </div>
                    </div>
                    <div style={{ width: "20%", cursor: "pointer" }}>
                      <div
                        className="p-3 text-white text-center rounded"
                        style={{ backgroundColor: "#6f42c1" }}
                      >
                        Generate Challan <br /> (801–1000 Students)
                      </div>
                    </div>
                  </div> */}

                  <div className="row">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="d-flex align-items-center">
                        <label htmlFor="rowsPerPage" className="me-2 mb-0">
                          Rows:
                        </label>
                        <div style={{ width: "150px" }}>
                          <select
                            id="rowsPerPage"
                            className="form-select form-select-sm"
                            value={perPage}
                            onChange={handlePerPageChange}
                            style={{
                              width: "80px", // or adjust as needed (80–120px)
                              paddingRight: "2rem", // ensures space for the dropdown arrow
                            }}
                          >
                            {[10, 20, 50, 100, 500].map((num) => (
                              <option key={num} value={num}>
                                {num}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div style={{ width: "200px" }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                    </div>
                    {isLoading ? (
                      <p>Loading...</p>
                    ) : (
                      <table
                        // id="challanTable"
                        className="table table-bordered table-striped"
                      >
                        <thead className="table-primary">
                          <tr>
                            <th>Sl No.</th>
                            <th>Name of Candidate</th>
                            <th>Gender</th>
                            <th>Date of Birth</th>
                            <th>Father's Name</th>
                            <th>Mother's Name</th>
                            <th>Aadhaar Number</th>
                            <th>Category</th>
                            <th style={{ textAlign: "start" }}>
                              Contact Number
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.length === 0 ? (
                            <tr>
                              <td colSpan="9" className="text-center">
                                No data found.
                              </td>
                            </tr>
                          ) : (
                            currentItems.map((row, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{row.candidatE_NAME}</td>
                                <td>{row.gender}</td>
                                <td>{row.dob}</td>
                                <td>{row.fatheR_NAME}</td>
                                <td>{row.motheR_NAME}</td>
                                <td>
                                  {row.aadhaR_CARD
                                    ? "********" + row.aadhaR_CARD.slice(-4)
                                    : ""}
                                </td>
                                <td>{row.studenT_EXAM_CATEGORY_DESCRIPTION}</td>
                                <td style={{ textAlign: "start" }}>
                                  {row.contacT_NO || ""}
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>

                        <tfoot>
                          <tr>
                            {filteredStudents.length > 0 &&
                              (parseDate(currentDate) >= parseDate(EndDate) ? (
                                <td colSpan="9">
                                  <span className="text-danger">
                                    <strong>Generate Challan Closed.</strong>
                                  </span>
                                </td>
                              ) : (
                                <td colSpan="9">
                                  <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={generateChallan}
                                  >
                                    <i className="fa fa-print"></i>{" "}
                                    &nbsp;Generate Challan
                                  </button>
                                </td>
                              ))}
                          </tr>
                        </tfoot>
                      </table>
                    )}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        Showing {(currentPage - 1) * perPage + 1} to{" "}
                        {Math.min(indexOfLastItem, filteredStudents.length)} of{" "}
                        {filteredStudents.length} entries
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <MdOutlineKeyboardDoubleArrowLeft
                          onClick={() => {
                            if (currentPage > 1) setCurrentPage(1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardArrowLeft
                          onClick={() => {
                            if (currentPage > 1)
                              setCurrentPage((prev) => prev - 1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <span>
                          Page {currentPage} of {totalPages}
                        </span>

                        <MdOutlineKeyboardArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage((prev) => prev + 1);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardDoubleArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage(totalPages);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer12 />
          </div>
        </div>
        <div className="modal fade" id="pdfModal" role="dialog" tabIndex="-1">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Challan PDF Preview</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal2}
                ></button>
              </div>
              <div className="modal-body">
                <iframe
                  ref={iframeRef}
                  width="100%"
                  height="500px"
                  style={{ border: "none" }}
                ></iframe>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeModal2}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GenerateChallan12;
